@let commonData = commonDataService.getData() | async;

<div class="d-none flex-column g-8 home-loading desktop">
  <div class="home-loading-header">
    <div class="d-flex align-items-center home-loading-header-wrapper justify-content-between">
      <img
        src="assets/images/{{ commonData?.headerImg }}"
        [alt]="commonData?.headerAlt"
        [width]="commonData?.headerImgWidth"
        [height]="commonData?.headerImgHeight"
      />

      <div class="d-flex justify-content-between align-items-center home-loading-header-block">
        <div class="d-flex align-items-center g-3">
          <ds-skeleton class="round" [width]="32" [height]="32" />
          <div class="d-flex flex-column g-1">
            <ds-skeleton class="radius-small" [width]="80" [height]="14" />
            <ds-skeleton class="radius-small" [width]="130" [height]="12" />
          </div>
        </div>

        <div class="d-flex align-items-center g-3">
          <ds-skeleton class="round" [width]="32" [height]="32" />
          <div class="d-flex flex-column g-1">
            <ds-skeleton class="radius-small" [width]="80" [height]="14" />
            <ds-skeleton class="radius-small" [width]="130" [height]="12" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column g-8 home-loading-body">
    <div class="d-flex align-items-center g-5">
      <div class="d-flex flex-column g-4">
        <div class="pl-4 d-flex align-items-center g-4">
          <ds-skeleton class="round" [width]="64" [height]="64" />
          <div class="d-flex flex-column gap-medium">
            <ds-skeleton class="radius-small" [width]="120" [height]="22" />
            <ds-skeleton class="radius-small" [width]="160" [height]="16" />
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-center card wallet-balance">
          <div
            class="wallet-balance-container d-flex flex-column align-items-center justify-content-between"
          >
            <div class="d-flex flex-column align-items-center g-2">
              <ds-skeleton class="radius-small" [width]="80" [height]="22" />
              <ds-skeleton class="radius-small" [width]="220" [height]="16" />
            </div>
            <ds-skeleton class="radius-small" [width]="130" [height]="28" />
          </div>
        </div>
      </div>

      <div class="w-100 d-flex align-items-center justify-content-between card next-adventure mr-7">
        <div class="d-flex flex-column g-6">
          <div class="d-flex flex-column g-2">
            <ds-skeleton class="radius-small" [width]="160" [height]="22" />
            <ds-skeleton class="radius-small" [width]="220" [height]="12" />
            <ds-skeleton class="radius-small" [width]="220" [height]="12" />
            <ds-skeleton class="radius-small" [width]="220" [height]="12" />
          </div>
          <ds-skeleton class="radius-small" [width]="220" [height]="40" />
        </div>
        <ds-skeleton class="round" [width]="202" [height]="202" />
      </div>
    </div>

    <div class="d-flex flex-column g-5 w-100">
      <ds-skeleton class="radius-small" [height]="34" [width]="220" />

      <div class="d-flex align-items-center g-6 card">
        <ds-skeleton class="filled left" [width]="420" [height]="224" />

        <div class="d-flex flex-column g-6">
          <div class="d-flex flex-column g-2">
            <ds-skeleton class="radius-small" [width]="160" [height]="22" />
            <ds-skeleton class="radius-small" [width]="420" [height]="12" />
            <ds-skeleton class="radius-small" [width]="420" [height]="12" />
            <ds-skeleton class="radius-small" [width]="420" [height]="12" />
          </div>

          <ds-skeleton class="radius-small" [width]="220" [height]="40" />
        </div>
      </div>
    </div>

    <div class="d-flex flex-column g-5 w-100">
      <ds-skeleton class="radius-small" [height]="34" [width]="220" />

      <div class="d-flex flex-column g-6 card">
        <ds-skeleton class="w-100 filled top" [height]="200" />

        <div class="d-flex flex-column g-2 pl-6 pb-6">
          <ds-skeleton class="radius-small" [width]="160" [height]="22" />
          <ds-skeleton class="radius-small" [width]="420" [height]="12" />
        </div>
      </div>
    </div>

    <need-help-card />
  </div>

  <footer></footer>
</div>

<div class="d-md-none flex-column g-4 home-loading">
  <div class="d-flex justify-content-between pr-3 pl-3 pt-4 pb-4 home-loading-header">
    <img
      src="assets/images/{{ commonData?.headerImg }}"
      [alt]="commonData?.headerAlt"
      [width]="commonData?.headerImgWidth"
      [height]="commonData?.headerImgHeight"
    />

    <div class="d-flex align-items-center g-3">
      <ds-skeleton class="round" [height]="24" [width]="24" />

      <img src="assets/icons/menu.svg" width="24" height="24" alt="menu" />
    </div>
  </div>

  <div class="d-flex flex-column p-4 home-loading-body g-6">
    <div class="d-flex flex-column g-4 w-100">
      <div class="d-flex align-items-center g-4">
        <ds-skeleton class="round" [width]="64" [height]="64" />
        <div class="d-flex flex-column gap-medium">
          <ds-skeleton class="radius-small" [width]="120" [height]="22" />
          <ds-skeleton class="radius-small" [width]="160" [height]="16" />
        </div>
      </div>

      <div class="card d-flex align-items-center justify-content-between w-100 p-4">
        <div class="d-flex flex-column gap-medium">
          <ds-skeleton class="radius-small" [height]="22" [width]="120" />
          <ds-skeleton class="radius-small" [height]="16" [width]="160" />
        </div>

        <ds-skeleton class="radius-small" [height]="28" [width]="80" />
      </div>
    </div>

    <div class="d-flex flex-column g-4">
      <ds-skeleton class="radius-small" [width]="220" [height]="24" />

      <div class="card">
        <ds-skeleton [height]="120" class="filled top w-100 radius-small" />
        <div class="d-flex flex-column g-6 p-4">
          <div class="d-flex flex-column g-2">
            <ds-skeleton class="radius-small" [width]="160" [height]="22" />
            <ds-skeleton class="radius-small" [width]="300" [height]="12" />
            <ds-skeleton class="radius-small" [width]="300" [height]="12" />
            <ds-skeleton class="radius-small" [width]="300" [height]="12" />
          </div>

          <ds-skeleton class="radius-small" [width]="220" [height]="40" />
        </div>
      </div>
    </div>

    <div class="card d-flex flex-column g-6 p-4">
      <div class="d-flex flex-column g-2">
        <ds-skeleton class="radius-small" [width]="160" [height]="22" />
        <ds-skeleton class="radius-small" [width]="300" [height]="12" />
        <ds-skeleton class="radius-small" [width]="300" [height]="12" />
        <ds-skeleton class="radius-small" [width]="300" [height]="12" />
      </div>

      <ds-skeleton class="radius-small" [width]="220" [height]="40" />
    </div>

    <div class="d-flex flex-column g-4">
      <ds-skeleton class="radius-small" [width]="220" [height]="24" />

      <div class="card">
        <ds-skeleton [height]="120" class="filled top w-100 radius-small" />
        <div class="d-flex flex-column g-2 p-4">
          <ds-skeleton class="radius-small" [width]="160" [height]="22" />
          <ds-skeleton class="radius-small" [width]="300" [height]="12" />
        </div>
      </div>
    </div>

    <need-help-card />
  </div>

  <footer></footer>
</div>
